/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_What_TitleInputs */

const fr_help_what_title = /** @type {(inputs: Help_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Qu'est-ce que Bus Tracker ?`)
};

const en_help_what_title = /** @type {(inputs: Help_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. What is Bus Tracker?`)
};

/**
* | output |
* | --- |
* | "1. What is Bus Tracker?" |
*
* @param {Help_What_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_what_title = /** @type {((inputs?: Help_What_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_What_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_what_title(inputs)
	return en_help_what_title(inputs)
});